import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import laundryImage from "../assets/image.png";
import { GlobeIcon } from "@radix-ui/react-icons";
import { CustomButton } from "../components/CustomButton";
import { ChevronDown } from "lucide-react";

export default function AuthScreen() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const [lang, setLang] = useState("EN");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex flex-col bg-white overflow-hidden">
      {/* Top Image */}
      <div className="w-full h-[35vh] relative bg-[#44B6CE] flex items-center justify-center shrink-0 shadow-lg shadow-cyan-100/50">
        <img
          src={laundryImage}
          alt="Rush Logo"
          className="object-contain"
          width={160}
          style={{ filter: "brightness(0) invert(1)" }}
        />

        {/* Language selector */}
        <div className="absolute top-12 right-6 flex flex-col items-end">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="flex items-center bg-white/20 backdrop-blur-md border border-white/30 rounded-2xl px-3 py-2 text-white text-xs font-bold transition-active active:scale-95"
          >
            <GlobeIcon className="mr-1.5 w-4 h-4" />
            <span>{lang}</span>
            <ChevronDown
              size={14}
              className={`ml-1 transition-transform ${isOpen ? "rotate-180" : ""}`}
            />
          </button>

          {isOpen && (
            <div className="mt-2 w-24 bg-white/10 backdrop-blur-lg border border-white/20 rounded-xl overflow-hidden shadow-xl animate-in fade-in zoom-in-95 duration-100">
              <button
                onClick={() => {
                  setLang("EN");
                  setIsOpen(false);
                }}
                className="w-full py-2.5 text-white text-[11px] font-bold hover:bg-white/10 transition-colors border-b border-white/10"
              >
                EN
              </button>
              <button
                onClick={() => {
                  setLang("AR");
                  setIsOpen(false);
                }}
                className="w-full py-2.5 text-white text-[11px] font-bold hover:bg-white/10 transition-colors"
              >
                AR
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-1 flex flex-col px-8 py-10 justify-between">
        {/* Text Section */}
        <div className="space-y-3">
          <h1 className="text-gray-900 text-3xl sm:text-4xl font-poppins leading-tight tracking-tight">
            Welcome To
            <span className="text-[#44B6CE]"> RUSH</span>
          </h1>
          <p className="text-gray-500 font-medium text-base leading-relaxed max-w-[300px]">
            Professional cleaning and real-time tracking, delivered right to
            your doorstep.
          </p>
        </div>

        {/* Action Buttons Section */}
        <div className="flex flex-col gap-4 mt-8">
          <CustomButton
            variant="primary"
            onClick={() => navigate("/login")}
            className="h-14 rounded-2xl text-lg font-bold shadow-xl shadow-cyan-100"
          >
            Log In
          </CustomButton>

          <CustomButton
            variant="outline"
            onClick={() => navigate("/signup")}
            className="h-14 rounded-2xl text-lg font-bold border-gray-200 text-gray-700 hover:bg-gray-50"
          >
            Create Account
          </CustomButton>

          <div className="fixed bottom-3 left-0 right-0 bg-white/80 backdrop-blur-md flex justify-between items-center px-6 py-4 border-t border-gray-50 text-[10px] text-gray-400 font-medium z-40">
            <span>COPYRIGHT © {new Date().getFullYear()} RUSH</span>

            <span>
              Powered By:{" "}
              <a
                href="https://infynixit.dev/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#44B6CE] hover:underline"
              >
                InfinixIT
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
